import { createAsyncThunk } from '@reduxjs/toolkit'
import { getLimboGameBetHistory, limboGamePlaceBet } from 'games/Limbo/services/limbo.service'
import { setLimboBetHistory } from 'games/Limbo/slice-thunk/limboGame.slice'
import { openErrorToaster } from 'utils/common-services/toaster.service'
import { generateClientSeed } from 'utils/common-functions/index'
import { setNewClientSeed, setServerSeedHash } from 'redux-store/redux/slices/gameSettings.slice'
import { enqueueCreditWalletWaitQueue, debitBalance } from 'redux-store/redux/slices/auth.slice'
import { BET_RESULT } from 'utils/constants/index'

export const getLimboGameBetRecord = createAsyncThunk(
  'limboGame/get-bet-history', async ({ limit, page }, thunkApi) => {
    try {
      const res = await getLimboGameBetHistory({ limit, page })
      return res
    } catch (error) {
      openErrorToaster(error[0].description)
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const limboGamePlacedBet = createAsyncThunk(
  'limboGame/place-bet', async ({ payload, isDemoGame, handleCancelAutoBet }, thunkApi) => {
    try {
      const res = await limboGamePlaceBet({ data: payload })
      const { limboBetHistory } = thunkApi?.getState()?.limboGame
      if (res) {
        thunkApi.dispatch(debitBalance(Number(res?.betAmount)))
        if (res?.result === BET_RESULT.WON) thunkApi.dispatch(enqueueCreditWalletWaitQueue(Number(res?.winningAmount)))
      }

      if (res?.nextServerSeedHash) {
        const newClientSeed = generateClientSeed()
        thunkApi.dispatch(setNewClientSeed(newClientSeed))
        thunkApi.dispatch(setServerSeedHash(res.nextServerSeedHash))
      }

      let newBetHistory = {}
      let rows = [{ ...res }]
      if (limboBetHistory) {
        rows = [...rows, ...limboBetHistory?.rows]
      }

      newBetHistory = { count: limboBetHistory?.count ? limboBetHistory?.count + 1 : 1, rows }
      thunkApi.dispatch(setLimboBetHistory(newBetHistory))
      return res
    } catch (error) {
      console.log(error)
      openErrorToaster(error[0].description)
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)
